/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-contract
 * OpenAPI spec version: 1.0.0
 */
import type {
  ContractLifecycleResponse,
  ContractResponse,
  ContractsResponse,
  DataloadContractsResponse,
  GetContractHeaders,
  GetContractLifecyclePathParameters,
  GetContractPathParameters,
  GetContractsBody,
  GetHealthHeaders,
  HealthResponse,
  ReactivateContractHeaders,
  ReactivateContractPathParameters,
  TerminateContractBody,
  TerminateContractHeaders,
  TerminateContractPathParameters,
  UpdateContractBody,
  UpdateContractHeaders,
  UpdateContractPathParameters,
} from "./types";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
import Axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";

import { type Logger, type HeaderProvider } from "@abacus/common";

import { type Throttler } from "@abacus/throttlers";

import { ApiResponse } from "./common";

export interface ApiConfig {
  auth?: HeaderProvider;
  axios?: AxiosInstance;
  baseUrl?: string;
  logger?: Logger;
  throttler?: Throttler;
}

export class OwsAbacusContractClient {
  auth?: HeaderProvider;
  axios: AxiosInstance;
  baseUrl: string;
  logger?: Logger;
  throttler?: Throttler;

  constructor(config?: ApiConfig) {
    this.auth = config?.auth;
    this.axios = config?.axios ?? Axios.create();
    this.baseUrl = config?.baseUrl ?? `https://localhost:8080`;
    this.logger = config?.logger;
    this.throttler = config?.throttler;
  }

  async _fetch<T>(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<ApiResponse<T>> {
    // On request
    config = await this._onRequest(config, options);
    // Make request
    const response = await this.axios(config);
    // Get data
    const data = response.data;
    const headers = response.headers as Record<string, string>;
    // Return response
    return { data, headers, status: response.status };
  }

  private async _getHeaders(
    headers?: Record<string, string>,
  ): Promise<Record<string, string>> {
    return {
      ...(await this.auth?.getHeaders()),
      ...headers,
    };
  }

  private async _onRequest(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<AxiosRequestConfig> {
    // Throttle the request
    await this.throttler?.wait();
    // Update config
    config = { ...config, ...options };
    // Add base URL
    config.baseURL ??= this.baseUrl;
    // Add headers
    const headers = config.headers as Record<string, string>;
    config.headers = await this._getHeaders(headers);
    // Log the request
    this.logger?.debug(`Requesting ${config.method} ${config.url}`);
    return config;
  }

  getContract(
    { contractId }: GetContractPathParameters,
    headers?: GetContractHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<ContractResponse>(
        { url: `/contract/${contractId}/`, method: "GET", headers },
        options,
      );
    }
  }

  updateContract(
    { contractId }: UpdateContractPathParameters,
    updateContractBody: UpdateContractBody,
    headers?: UpdateContractHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<ContractResponse>(
        {
          url: `/contract/${contractId}/`,
          method: "PUT",
          headers: { "Content-Type": "application/json", ...headers },
          data: updateContractBody,
        },
        options,
      );
    }
  }

  getContractLifecycle(
    { contractId }: GetContractLifecyclePathParameters,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<ContractLifecycleResponse>(
        { url: `/contract/${contractId}/contract-lifecycle/`, method: "GET" },
        options,
      );
    }
  }

  terminateContract(
    { contractId }: TerminateContractPathParameters,
    terminateContractBody: TerminateContractBody,
    headers?: TerminateContractHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<ContractResponse>(
        {
          url: `/contract/${contractId}/terminate/`,
          method: "PUT",
          headers: { "Content-Type": "application/json", ...headers },
          data: terminateContractBody,
        },
        options,
      );
    }
  }

  reactivateContract(
    { contractId }: ReactivateContractPathParameters,
    headers?: ReactivateContractHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<ContractResponse>(
        { url: `/contract/${contractId}/reactivate/`, method: "PUT", headers },
        options,
      );
    }
  }

  getContracts(
    getContractsBody: GetContractsBody,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<ContractsResponse>(
        {
          url: `/contracts/`,
          method: "POST",
          headers: { "Content-Type": "application/json" },
          data: getContractsBody,
        },
        options,
      );
    }
  }

  dataloadContracts(
    getContractsBody: GetContractsBody,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<DataloadContractsResponse>(
        {
          url: `/contracts/dataloader/`,
          method: "POST",
          headers: { "Content-Type": "application/json" },
          data: getContractsBody,
        },
        options,
      );
    }
  }

  getHealth(
    headers?: GetHealthHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<HealthResponse>(
        { url: `/hello/`, method: "GET", headers },
        options,
      );
    }
  }
}
